'use client';

import { ComponentProps, FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { BasicModalDialog } from './BasicModalDialog';

interface Props extends ComponentProps<typeof BasicModalDialog> {}

export const BasicModal: FC<Props> = (props) => {
  const [isMounted, setIsMounted] = useState<boolean>(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted && props.isOpen ? createPortal(<BasicModalDialog {...props} />, document.body, 'basicModal') : null;
};
